import { useQuery } from '@tanstack/react-query';

import { bannersQueryOptions } from '@/queries/upgrade/banners';

/**
 * A hook to get you banners from API
 */
export const useBanners = () => {
  const { data } = useQuery(bannersQueryOptions());

  return data;
};
